import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const IconFormEdit = (props) => {
  const { color = 'text.disabled', ...other } = props;

  const svg = (
    <svg width="24" height="24" viewBox="0 0 18 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.0168 15.2243H5.64893V13.6219H10.6124L9.0168 15.2243ZM7.65953 19.2308V17.6281H1.59576V1.60255H9.11181V6.18584H13.7234V10.4976L15.3192 8.89494L15.3192 5.43271L9.90956 0H1.59576C1.16496 0 0.791327 0.158886 0.474685 0.476705C0.158043 0.794524 0 1.17003 0 1.60255V17.6281C0 18.0608 0.158043 18.4361 0.474685 18.7541C0.791327 19.0719 1.16496 19.2308 1.59576 19.2308L7.65953 19.2308Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.38301 20V17.0433L14.6729 11.7548C14.8165 11.6106 14.9761 11.5064 15.1516 11.4423C15.3271 11.3782 15.5027 11.3462 15.6782 11.3462C15.8697 11.3462 16.0532 11.3822 16.2287 11.4543C16.4043 11.5264 16.5638 11.6346 16.7074 11.7789L17.5931 12.6683C17.7314 12.8125 17.8338 12.9728 17.9002 13.149C17.9667 13.3253 18 13.5016 18 13.6779C18 13.8542 17.9655 14.0345 17.8964 14.2188C17.8271 14.403 17.7211 14.5673 17.5785 14.7115L12.3271 20H9.38301ZM11.7287 18.5577H10.8191V17.6442L13.7394 14.7356L14.625 15.625L11.7287 18.5577Z"
        fill={color}
      />
      <path
        d="M4.77236 14.4208C4.77236 14.8619 4.41622 15.2196 3.97688 15.2196C3.53755 15.2196 3.18141 14.8619 3.18141 14.4208C3.18141 13.9796 3.53755 13.6219 3.97688 13.6219C4.41622 13.6219 4.77236 13.9796 4.77236 14.4208Z"
        fill={color}
      />
      <path
        d="M4.77236 11.5738C4.77236 12.0149 4.41622 12.3726 3.97688 12.3726C3.53755 12.3726 3.18141 12.0149 3.18141 11.5738C3.18141 11.1326 3.53755 10.7749 3.97688 10.7749C4.41622 10.7749 4.77236 11.1326 4.77236 11.5738Z"
        fill={color}
      />
      <path
        d="M5.64893 12.3775H11.5054V10.7749H5.64893V12.3775Z"
        fill={color}
      />
      <path
        d="M4.77236 8.70401C4.77236 9.14516 4.41622 9.50285 3.97688 9.50285C3.53755 9.50285 3.18141 9.14516 3.18141 8.70401C3.18141 8.26285 3.53755 7.90516 3.97688 7.90516C4.41622 7.90516 4.77236 8.26285 4.77236 8.70401Z"
        fill={color}
      />
      <path
        d="M5.64893 9.50777H11.5054V7.90516H5.64893V9.50777Z"
        fill={color}
      />
    </svg>
  );

  return (
    <Box component="span" display="block" {...other}>
      {svg}
    </Box>
  );
};

IconFormEdit.propTypes = {
  color: PropTypes.string,
  fontSize: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};

export default IconFormEdit;
